import { specialChars } from '../constants/special-chars';

/**
 * Function that generates "slug" based on "displayName".
 * @param displayName - Display name of the service from which slug is generated.
 * @returns The generated slug.
 */
 export function generateSlug(displayName: string, slugId? : string) {
  const separator = '-';
  const trimmedDisName = displayName.trim();
  let mappedSplChrsText = '';

  for (let i = 0; i < trimmedDisName.length; i++) {
    mappedSplChrsText += specialChars[trimmedDisName[i]] || trimmedDisName[i];
  }
  const regex = /[^a-zA-Z0-9]+/g;

  let slug = mappedSplChrsText
    .replace(/^\s+|\s+$/g, '')
    .replace(/[_|\s]+/g, separator)
    .replace(/[^a-zA-z\u0400-\u04FF0-9-%-]+/g, '')
    .replace(/[-]+/g, separator)
    .replace(/^-+|-+$/g, '')
    .replace(/[-]+/g, separator)
    .toLowerCase();
  
  let schemeUrl = slug; 

  if (slugId) {
    schemeUrl = slug.replace(regex, '-'); 
  }
  
  return slugId ? `${schemeUrl}_${slugId}.html` : slug ? `${slug}.html` : '';
}
